"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_student_report_cards_html_1 = __importDefault(require("./admin-student-report-cards.html"));
var admin_student_report_cards_controller_1 = __importDefault(require("./admin-student-report-cards.controller"));
function getReportcard(UsersModel, $stateParams) {
    return UsersModel.getStudentReportcards({
        id: $stateParams.userId,
        page_by: 20,
    }).then(function (response) {
        return response.reportcards;
    });
}
getReportcard.$inject = ["UsersModel", "$stateParams"];
function getStudent(UsersModel, $stateParams) {
    return UsersModel.getStudentByID($stateParams.userId).then(function (response) {
        return response;
    });
}
getStudent.$inject = ["UsersModel", "$stateParams"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.students.view.reportcards", {
        url: "/report-cards",
        controller: admin_student_report_cards_controller_1.default,
        controllerAs: "vm",
        template: admin_student_report_cards_html_1.default,
        resolve: {
            reportcards: getReportcard,
            student: getStudent,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.students.view.reportcards", [])
    .config(config)
    .controller("AdminStudentReportCardsController", admin_student_report_cards_controller_1.default);
